<template>
  <drag-dialog
    :title="title"
    :width="750"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="cancel"
    class="custom-dialog">
    <div class="custom-tabs-box">
      <div class="tabs-item-box">
        <div
          :class="`tab-box ${isActive('changeLogs') ? 'active-item' : ''}`"
          @click="onTabClick('changeLogs')">
          变更日志({{ versionList.length }})
        </div>
        <div
          v-if="isChecked('DataSet.VersionContrast.QueryList')"
          :class="`tab-box ${isActive('versionCompare') ? 'active-item' : ''}`"
          @click="onTabClick('versionCompare')">
          版本对比
        </div>
      </div>
      <div class="tabs-content-box">
        <div
          class="version-box"
          v-if="activeTab === 'changeLogs'">
          <div class="common-table-box">
            <el-table
              highlight-selection-row
              ref="versionTable"
              class="publish-table"
              :header-row-class-name="customHeader"
              :data="versionList"
              height="100%">
              <el-table-column
                type="expand"
                width="1">
                <template slot-scope="props">
                  <div class="common-child-table-box">
                    <el-table :data="props.row.detailItems">
                      <el-table-column
                        label="子文件"
                        width="180">
                        <template v-slot="{ row }">
                          <span
                            class="text-overflow"
                            :title="row.displayName">
                            {{ row.displayName }}
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column label="更新时间">
                        <template v-slot="{ row }">
                          <span
                            class="text-overflow"
                            :title="row.updatedTime">
                            {{ row.updatedTime }}
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="变更方式"
                        width="150">
                        <template v-slot="{ row }">
                          <span
                            class="text-overflow"
                            :title="row.actionName">
                            {{ formatActionName(row.actionName) }}
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="版本号"
                width="180">
                <template v-slot="{ row }">
                  <span
                    class="text-overflow"
                    :title="`V${row.version}`">
                    V{{ row.version }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="转换完成时间">
                <template v-slot="{ row }">
                  <span>{{ formatTime(row.convertCompleteTime) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="150">
                <template v-slot="{ row }">
                  <div class="common-button-box operation-cell">
                    <el-button
                      type="text"
                      size="small"
                      @click="viewModel(row)"
                      >查看模型</el-button
                    >
                    <el-button
                      type="text"
                      size="small"
                      @click="onExpand(row)">
                      <span>详情</span>
                      <i
                        :class="`el-icon-caret-bottom icon ${
                          row.expand ? 'expanded-icon' : ''
                        }`"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div
          class="compare-box"
          v-if="activeTab === 'versionCompare'">
          <div
            v-if="compareLoading"
            class="loading-box">
            <Spin
              :pointNum="8"
              :translateX="25"
              background="var(--base-primary-bgColor)" />
          </div>
          <div
            v-else
            class="compare-content-box">
            <div v-if="supportCompareFlag">
              <div class="compare-select-box">
                <div class="version-item-box">
                  <div class="title">更新前版本：</div>
                  <div class="common-select-box">
                    <el-select
                      class="primary-select"
                      size="small"
                      :popper-append-to-body="false"
                      v-model="fromVersion">
                      <el-option
                        v-for="(item, index) in versionList"
                        :key="index"
                        :label="`v${item.version}`"
                        :value="item.version">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="split-icon">
                  <icon-svg icon-class="ic-duibi" />
                </div>
                <div class="version-item-box">
                  <div class="title">更新后版本：</div>
                  <div class="common-select-box">
                    <el-select
                      class="primary-select"
                      size="small"
                      :popper-append-to-body="false"
                      v-model="toVersion">
                      <el-option
                        v-for="(item, index) in versionList"
                        :key="index"
                        :label="`v${item.version}`"
                        :value="item.version">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div
                  class="common-button-box"
                  v-if="isChecked('DataSet.VersionContrast.Create')">
                  <el-button
                    class="primary-btn"
                    type="text"
                    size="small"
                    @click="startCompare"
                    >发起对比</el-button
                  >
                </div>
              </div>
              <div
                class="common-table-box"
                v-loading="tableLoading">
                <el-table
                  ref="versionTable"
                  v-if="compareList.length"
                  :data="compareList"
                  class="publish-table"
                  :header-row-class-name="customHeader"
                  height="100%">
                  <el-table-column
                    label="序号"
                    type="index"
                    width="75"></el-table-column>
                  <el-table-column
                    label="对比版本"
                    prop="versionDesc">
                  </el-table-column>
                  <el-table-column
                    label="对比状态"
                    width="120">
                    <template v-slot="{ row }">
                      <div
                        v-if="row.status === 0"
                        class="status-text">
                        <div class="circle bg-color1"></div>
                        <span class="color1">{{ row.statusDes }}</span>
                      </div>
                      <div
                        v-else-if="row.status === 1"
                        class="status-text">
                        <div class="circle bg-color2"></div>
                        <span class="color2">{{ row.statusDes }}</span>
                      </div>
                      <div
                        v-else-if="row.status === -1"
                        class="status-text">
                        <div class="circle bg-color3"></div>
                        <span class="color3">{{ row.statusDes }}</span>
                        <span
                          class="re-compare-icon"
                          title="重新发起对比"
                          @click="reCompare(row)">
                          <icon-svg icon-class="ic-ico_upload" />
                        </span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="对比时间"
                    width="180">
                    <template v-slot="{ row }">
                      <div>{{ formatTime(row.contrastTime) }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template v-slot="{ row }">
                      <div
                        class="common-button-box operation-cell"
                        v-if="
                          isChecked('DataSet.VersionContrast.ViewContrast')
                        ">
                        <el-button
                          type="text"
                          size="small"
                          :disabled="row.status !== 1"
                          @click="viewCompareResult(row)"
                          >查看模型</el-button
                        >
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div
              v-else
              class="common-empty-box">
              <bj-empty
                :image="require('@/assets/img/no-data.png')"
                class="empty-page">
                <template slot="description">
                  <div class="public-tips-primary">
                    当前版本对比功能仅针对以下格式：rvt、dgn、gim、3dm、xds
                  </div>
                </template>
              </bj-empty>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="common-button-box footer-btn-box dialog-footer">
      <el-button
        class="primary-btn"
        type="primary"
        size="small"
        @click="cancel"
        >关闭</el-button
      >
    </div>
  </drag-dialog>
</template>

<script>
import dragDialog from '@/components/CustomDragDialog.vue'
import Spin from '@/components/Spin.vue'

import {
  getVersionChangelog,
  isCompareService,
  startVersionContrast,
  getVersionContrastList
} from '@/service/interface'
import { formatTime } from '@/utils/generalMethods'

import { Store } from '@/utils/store'
import { isMicroAppMode, helper } from '@/microAdapt/utils'
export default {
  data() {
    return {
      activeTab: 'changeLogs',
      title: '',
      versionList: [],
      selectedVersion: {},

      compareLoading: true,
      supportCompareFlag: false,
      fromVersion: '',
      toVersion: '',
      tableLoading: false,
      compareList: [],
      customHeader: '',
      timer: null
    }
  },
  props: {
    visible: Boolean,
    versionInfo: Object,
    closeDialog: Function
  },
  components: {
    dragDialog,
    Spin
  },
  mounted() {
    const currentBody = this.$refs.versionTable?.bodyWrapper
    currentBody &&
      currentBody.addEventListener('scroll', ev => {
        const scrollTop = ev.target.scrollTop
        this.customHeader = scrollTop > 10 ? 'darkHeader' : ''
      })
  },
  watch: {
    versionInfo: function (newVal) {
      if (Object.keys(newVal).length) {
        let versionInfo = newVal
        this.title = versionInfo.dataSetName
        this.versionList = versionInfo.versionList

        this.fromVersion = this.versionList[1].version
        this.toVersion = this.versionList[0].version
      }
    }
  },
  methods: {
    onTabClick(tabName) {
      this.activeTab = tabName
      if (tabName === 'versionCompare') {
        this.isCompareFlag().then(supportCompareFlag => {
          if (supportCompareFlag) {
            this.getCompareList()
          }
        })
      } else {
        this.timer && clearInterval(this.timer)
        this.timer = null
      }
    },
    isActive(activeTab) {
      return this.activeTab === activeTab
    },
    /**
     * 是否可以进行版本对比
     */
    isCompareFlag() {
      this.compareLoading = true
      return new Promise(resolve => {
        let dataSetId = this.versionInfo.dataSetId
        isCompareService({ dataSetId }).then(response => {
          if (response.isSuccess) {
            let supportCompareFlag = response.data
            this.supportCompareFlag = supportCompareFlag
            this.compareLoading = false
            resolve(supportCompareFlag)
          }
        })
      })
    },
    getCompareList() {
      this.tableLoading = true
      let dataSetId = this.versionInfo.dataSetId
      getVersionContrastList({ params: { dataSetId } }).then(response => {
        if (response.isSuccess) {
          let data = response.data
          let compareList = data.items

          this.timer && clearInterval(this.timer)
          this.timer = null
          let comparing = compareList.filter(el => el.status === 0)
          if (comparing.length) {
            this.timer = setInterval(this.refreshVersionCompareList, 5000)
          }

          this.compareList = compareList

          this.tableLoading = false
        }
      })
    },
    refreshVersionCompareList() {
      let dataSetId = this.versionInfo.dataSetId
      getVersionContrastList({ params: { dataSetId } }).then(response => {
        if (response.isSuccess) {
          let data = response.data

          let compareList = data.items
          let comparing = compareList.filter(el => el.status === 0)

          if (!comparing.length) {
            this.timer && clearInterval(this.timer)
            this.timer = null
          }
          this.compareList = compareList
        }
      })
    },
    cancel() {
      this.activeTab = 'changeLogs'
      this.closeDialog()
    },
    viewModel(versionInfo) {
      const routerUrl = this.$router.resolve({
        path: `../../versionView`,
        query: {
          dataSetId: this.versionInfo.dataSetId,
          dataSetName: this.versionInfo.dataSetName,
          versionId: versionInfo.version
        }
      })

      if (
        isMicroAppMode() &&
        typeof helper.versionSceneViewCallBack === 'function'
      ) {
        helper.versionSceneViewCallBack(routerUrl.href)
      } else {
        window.open(routerUrl.href, '_blank')
      }
    },
    startCompare() {
      if (this.fromVersion >= this.toVersion) {
        this.$message.warning('更新前的版本号必须小于更新后的版本号')
        return
      }

      let params = {
        dataSetId: this.versionInfo.dataSetId,
        fromVersion: this.fromVersion,
        toVersion: this.toVersion
      }
      this.tableLoading = true
      startVersionContrast(params).then(response => {
        if (response.isSuccess) {
          this.getCompareList()
        } else {
          this.tableLoading = false
          this.$message.warning(response.errMsg)
        }
      })
    },
    reCompare(data) {
      let params = {
        dataSetId: data.dataSetId,
        fromVersion: data.fromVersion,
        toVersion: data.toVersion
      }
      this.tableLoading = true
      startVersionContrast(params).then(response => {
        if (response.isSuccess) {
          this.getCompareList()
        } else {
          this.$message.warning(response.errMsg)
        }
      })
    },
    viewCompareResult(row) {
      let dataSetId = this.versionInfo.dataSetId
      let dataSetName = this.versionInfo.dataSetName
      let fromVersion = row.fromVersion
      let toVersion = row.toVersion

      const routerUrl = this.$router.resolve({
        path: `../../versionCompare`,
        query: {
          dataSetId: dataSetId,
          dataSetName: dataSetName,
          fromVersion: fromVersion,
          toVersion: toVersion
        }
      })

      if (
        isMicroAppMode() &&
        typeof helper.versionSceneViewCallBack === 'function'
      ) {
        helper.versionSceneViewCallBack(routerUrl.href)
      } else {
        window.open(routerUrl.href, '_blank')
      }
    },
    onExpand(row) {
      if (row.detailItems) {
        row.expand = !row.expand

        this.$nextTick(() => {
          this.$refs.versionTable.toggleRowExpansion(row)
        })
      } else {
        let versionId = row.versionId
        getVersionChangelog(versionId).then(response => {
          if (response.isSuccess) {
            let detailItems = response.data
            row.detailItems = detailItems
            row.expand = !row.expand

            this.$nextTick(() => {
              this.$refs.versionTable.toggleRowExpansion(row)
            })
          }
        })
      }
    },
    formatActionName(actionName) {
      return actionName.replace('转换', '')
    },
    queryChangeLogs(versionId) {
      return new Promise(resolve => {
        getVersionChangelog(versionId).then(response => {
          if (response.isSuccess) {
            let changeLogs = response.data
            this.changeLogs = changeLogs
            resolve()
          }
        })
      })
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    formatTime
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';

.custom-tabs-box {
  display: flex;
  margin-top: -16px;

  .tabs-item-box {
    padding-top: 16px;
    padding-right: 16px;
    border-right: 1px solid var(--dialog-split-line-color);

    .tab-box {
      border-radius: 8px;
      width: 120px;
      font-size: 14px;
      padding: 6px 7px;
      margin-bottom: 10px;
      background: var(--tab-bgColor);
      color: var(--tab-text-color);
      text-align: center;
      cursor: pointer;

      &:hover {
        color: var(--tab-text-color);
        background-color: var(--tab-hover-bgColor);
      }

      &.active-item {
        color: var(--base-primary-bgColor);
        background-color: var(--base-bg-light-color24);
      }
    }
  }

  .tabs-content-box {
    flex-grow: 1;
    padding-left: 15px;
    padding-top: 16px;
    overflow: hidden;

    .compare-box {
      width: 100%;
      height: 360px;
      margin-bottom: 10px;

      .loading-box {
        position: relative;
        width: 100%;
        height: 100%;
      }

      .compare-content-box {
        height: 100%;
      }

      .compare-select-box {
        display: flex;
        align-items: center;
        text-align: left;
        line-height: 32px;

        .version-item-box {
          display: flex;
          margin-right: 15px;
          font-size: 14px;

          .title {
            width: 150px;
            color: var(--default-color);
            margin-bottom: 5px;
          }
        }

        .split-icon {
          font-size: 20px;
          color: var(--tab-icon-color);
          margin-right: 15px;
        }
      }

      .common-table-box {
        margin: 10px 0px;
        height: 300px;

        :deep(.el-table) {
          .el-table__header-wrapper {
            border-radius: 4px;

            .el-table__header {
              .el-table__cell {
                &:nth-child(2) {
                  padding: 0px 10px;
                }
              }
            }
          }

          .el-table__body-wrapper {
            tr {
              .el-table__cell {
                &:first-child {
                  border-radius: 4px 0 0 4px;
                }

                &:last-child {
                  border-radius: 0 4px 4px 0;
                }

                &:nth-child(2) {
                  padding: 0px 10px;
                }
              }
            }
          }
        }

        :deep(.el-loading-mask) {
          background-color: transparent;
        }

        .status-text {
          display: flex;
          .circle {
            width: 5px;
            height: 5px;
            margin: auto 10px auto 0px;
            border-radius: 50%;
          }

          .re-compare-icon {
            color: var(--primary-color);
            margin: 0px 5px;
            cursor: pointer;
          }

          .bg-color1 {
            background: #3588fa;
          }

          .bg-color2 {
            background: #73fbfd;
          }

          .bg-color3 {
            background: #f56c6c;
          }

          .color1 {
            color: #3588fa;
          }

          .color2 {
            color: #73fbfd;
          }

          .color3 {
            color: #f56c6c;
          }
        }
      }

      .common-empty-box {
        color: var(--default-color);
      }
    }

    .version-box {
      width: 100%;
      height: 360px;
      margin-bottom: 10px;
      .common-table-box {
        height: 100%;

        :deep(.el-table) {
          .el-table__header-wrapper {
            border-radius: 4px;

            .el-table__header {
              .el-table__cell {
                &:nth-child(2) {
                  padding: 0px 10px;
                }
              }
            }
          }

          .el-table__body-wrapper {
            // .expanded {
            // }

            tr {
              background: transparent;

              .el-table__cell {
                &:first-child {
                  border-radius: 4px 0 0 4px;
                }

                &:last-child {
                  border-radius: 0 4px 4px 0;
                }

                &:nth-child(2) {
                  padding: 0px 10px;
                }
              }
            }

            .el-table__expanded-cell {
              border-color: transparent;
              background: transparent;

              .common-child-table-box {
                .el-table__header {
                  .el-table__cell {
                    background-color: var(--table-expand-bgColor);

                    &:nth-child(2) {
                      padding-left: 0px;
                    }
                  }
                }

                .el-table__body {
                  td {
                    &.el-table__cell {
                      background-color: var(--table-expand-bgColor);
                    }
                  }
                }
              }
            }
          }

          & > .el-table__body-wrapper {
            .el-table__row {
              .el-table__expand-column {
                // display: none;
                background: transparent;

                & + .el-table__cell {
                  border-top-left-radius: 4px;
                  border-bottom-left-radius: 4px;
                }
              }
            }
          }
        }

        .common-button-box {
          display: flex;

          .icon {
            margin-right: 5px;
          }

          .expanded-icon {
            transform: rotate(180deg);
            transition: transform 0.3s ease-in-out;
          }
        }
      }
    }
  }
}

.footer-btn-box {
  width: calc(100% + 32px) !important;
  margin-left: -16px;
  text-align: right;
}
</style>
